import { Dtos, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import {
	bondRequestPreviewsQueryKey,
	bondRequestsQueryKey,
} from "../../bond-request/bond-request.keys";
import { accountPreviewsQueryKey } from "../../previews/previews.keys";
import { accountBondingLineQueryKey, accountQueryKey } from "../account.keys";

export const useAdminUpdateSuretyAccountBondingLines = (accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { put } = useRequest();

	const mutation = useMutation({
		mutationKey: ["updateSuretyAccountBondingLines", accountId],
		mutationFn: async (data: Dtos.Admin.SuretyAccount.Update.BondingLines.Request) => {
			await put(`/v2/admin/surety/accounts/${accountId}/bonding-lines`, data, "none");
		},
		onSuccess: async () => {
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: bondRequestsQueryKey() }),
				queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) }),
				queryClient.invalidateQueries({ queryKey: accountBondingLineQueryKey(accountId) }),
				queryClient.invalidateQueries({ queryKey: accountPreviewsQueryKey() }),
				queryClient.invalidateQueries({ queryKey: bondRequestPreviewsQueryKey() }),
			]);
		},
	});

	return {
		updateSuretyAccountBondingLines: mutation.mutate,
		updateSuretyAccountBondingLinesIsLoading: mutation.isPending,
	};
};
